

import { TroubleshootTwoTone } from "@mui/icons-material";

const { createSlice } = require("@reduxjs/toolkit");

export const initialState = {
  // endDate: moment(new Date().setDate(new Date().getDate() + 364)).format(
  //   "YYYY-MM-DD"
  // ),

  //   pinCode: "",
  //   userName: "",

  scheduleState: true,
  unscheduleState: true,
  pauseState: true,
  runningState: true,
  stopState: true,
  processState: true,

  actionid: {
    type: "pages/actionid",
    payload: "1",
  },
  refreshState: "",
  refreshrunning: "",
  runninglist: [],
  stoppedlist: [],
  schedulelist: [],
  processlist: [],
  mainSkelton: "",
  BulkUploadList: "",
  andState: "",
  AndOrActionState: "",
  // TwofactAuth:
  //   localStorage.getItem("is2FactorAuth") != null
  //     ? localStorage.getItem("is2FactorAuth")
  //     : "0",
  TwofactAuth:
  localStorage.getItem("is2FactorAuth") == null ||
  localStorage.getItem("is2FactorAuth") == 0
    ? "0"
    : localStorage.getItem("is2FactorAuth"),
};

const pageSlice = createSlice({
  name: "pages",
  initialState,
  reducers: {
    // scheduleState: (state, payload) => {
    //   state.scheduleState = payload;
    // },
    // unscheduleState: (state, payload) => {
    //   state.unscheduleState = payload;
    // },
    pauseState: (state, payload) => {
      state.pauseState = payload;
    },
    runningState: (state, payload) => {
      state.runningState = payload;
    },
    stopState: (state, payload) => {
      state.stopState = payload;
    },
    actionid: (state, payload) => {
      state.actionid = payload;
    },
    resumeState: (state, payload) => {
      state.resumeState = payload;
    },
    processState: (state, payload) => {
      state.processState = payload;
    },
    refresh: (state, payload) => {
      state.refresh = payload;
    },
    refreshrunning: (state, payload) => {
      state.refreshrunning = payload;
    },
    runninglist: (state, payload) => {
      state.runninglist = payload;
    },
    stoppedlist: (state, payload) => {
      state.stoppedlist = payload;
    },
    schedulelist: (state, payload) => {
      state.schedulelist = payload;
    },
    processlist: (state, payload) => {
      state.processlist = payload;
    },
    mainSkelton: (state, payload) => {
      state.mainSkelton = payload;
    },
    BulkUploadList: (state, payload) => {
      state.BulkUploadList = payload;
    },
    andState: (state, { payload }) => {
      // alert("in")
      console.log({ payload });
      state.andState = payload;
    },
    AndOrActionState: (state, payload) => {
      // alert("in")
      state.AndOrActionState = payload;
    },
    TwofactAuth: (state, { payload }) => {
      // alert("in")
      state.TwofactAuth = payload;
    },
  },
});

export const {
  scheduleState,
  unscheduleState,
  pauseState,
  runningState,
  stopState,
  processState,
  actionid,
  resumeState,
  refresh,
  refreshrunning,
  runninglist,
  stoppedlist,
  schedulelist,
  processlist,
  mainSkelton,
  BulkUploadList,
  andState,
  AndOrActionState,
  TwofactAuth,
} = pageSlice.actions;

export default pageSlice.reducer;
